import Toast, { combineDateAndTime, requestHandler } from "utils";
import api from "../utils/axios";

export const GetEventBody = (eventDetails) => {
  // // Combine start date and time
  const combinedStart = combineDateAndTime(
    eventDetails.starts,
    eventDetails.startHours?.value,
    eventDetails.startMinutes?.value
  );

  // // Combine end date and time
  const combinedEnd = combineDateAndTime(
    eventDetails.ends,
    eventDetails.endHours?.value,
    eventDetails.endMinutes?.value
  );

  const combinedLastEnd = combineDateAndTime(
    eventDetails.last_entry_time,
    eventDetails.lastEndHours?.value ,
    eventDetails.lastEndMinutes?.value,
  );

  const form = new FormData();

  // Update the eventDetails with combined start and end
  const updatedEventDetails = {
    ...eventDetails,
    starts: new Date(combinedStart).toISOString(),
    ends: new Date(combinedEnd).toISOString(),
    on_sale_from: new Date(combinedStart).toISOString(),
    on_sale_to: new Date(combinedEnd).toISOString(),
    age_restrictions: eventDetails?.age_restrictions * 1,
    last_entry_time: new Date(combinedLastEnd).toISOString(),
    organiser_name: eventDetails?.organiser_name?.value,
    event_visibility: eventDetails?.event_visibility,
    startHours: eventDetails?.startHours?.value,
    startMinutes: eventDetails?.startMinutes?.value,
    endHours: eventDetails?.endHours?.value,
    endMinutes: eventDetails?.endMinutes?.value,
    lastEndHours: eventDetails?.lastEndHours?.value,
    lastEndMinutes: eventDetails?.lastEndMinutes?.value,
    booking_fee_percentage: Number(eventDetails?.booking_fee_percentage),
    installments_enabled: eventDetails?.installments_enabled || false,
    installment_plans: eventDetails?.installments_enabled 
      ? (Array.isArray(eventDetails?.installment_plans) 
          ? eventDetails.installment_plans.map(p => p.value || p)
          : [])
      : [],
    installment_cutoff_days: eventDetails?.installments_enabled 
      ? parseInt(eventDetails?.installment_cutoff_days || 0, 10)
      : 0,
    installment_billing_type: eventDetails?.installments_enabled
      ? (eventDetails?.installment_billing_type || "monthly_cycle")
      : null,
    // event_image: "test_image",
  };

  delete updatedEventDetails["endHours"];
  delete updatedEventDetails["endMinutes"];
  delete updatedEventDetails["startHours"];
  delete updatedEventDetails["startMinutes"];
  delete updatedEventDetails["lastEndHours"];
  delete updatedEventDetails["lastEndMinutes"];

  // installment_min_amount is ticket/package level only, not event level
  delete updatedEventDetails["installment_min_amount"];
  delete updatedEventDetails["installments_eligible"];

  return updatedEventDetails;
};

export const GetTicketBody = (ticketDetails) => {

  try {
    // Combine start date and time
    const combinedStart = combineDateAndTime(
      ticketDetails.on_sale_from,
      ticketDetails.startHours?.value,
      ticketDetails.startMinutes?.value
    );
    // const combinedStart = combineDateAndTime(
    //   ticketDetails.on_sale_from || new Date().toISOString().split('T')[0], 
    //   ticketDetails.startHours?.value ?? 0, // Default to midnight
    //   ticketDetails.startMinutes?.value ?? 0 // Default to 0 minutes
    // );
  
    // Combine end date and time
    const combinedEnd = combineDateAndTime(
      ticketDetails.on_sale_to,
      ticketDetails.endHours?.value,
      ticketDetails.endMinutes?.value
    );

    // const combinedEnd = combineDateAndTime(
    //   ticketDetails.on_sale_to || new Date().toISOString().split('T')[0],
    //   ticketDetails.endHours?.value ?? 23, // Default to 11 PM
    //   ticketDetails.endMinutes?.value ?? 59 // Default to 59 minutes
    // );
  
  
  
    
    // Update the eventDetails with combined start and end
    
    const updatedEventDetails = {
      ...ticketDetails,
      starts: new Date(combinedStart).toISOString(),
      ends: new Date(combinedEnd).toISOString(),
      on_sale_from: new Date(combinedStart).toISOString(),
      on_sale_to: new Date(combinedEnd).toISOString(),
      booking_fee:Number(ticketDetails?.booking_fee),
      customer_pays:Number(ticketDetails?.customer_pays),
      price:Number(ticketDetails?.price),
      you_receive:Number(ticketDetails?.you_receive),
      age_restrictions:Number(ticketDetails?.age_restrictions),
      organiser_name:Number(ticketDetails?.organiser_name),
      startHours: ticketDetails?.startHours?.value,
      startMinutes: ticketDetails?.startMinutes?.value,
      endHours: ticketDetails?.endHours?.value,
      endMinutes: ticketDetails?.endMinutes?.value,
      lastEndHours: ticketDetails?.lastEndHours?.value,
      lastEndMinutes: ticketDetails?.lastEndMinutes?.value,
      is_password_protected: ticketDetails?.is_password_protected ?? false,
      password: ticketDetails?.is_password_protected 
        ? (ticketDetails?.password !== undefined && ticketDetails?.password !== null ? ticketDetails.password : null) 
        : null,
      installments_eligible: ticketDetails?.installments_eligible || false,
      installment_plans: ticketDetails?.installments_eligible
        ? (Array.isArray(ticketDetails?.installment_plans)
            ? ticketDetails.installment_plans.map(p => p.value || p)
            : [])
        : [],
      installment_min_amount: ticketDetails?.installments_eligible
        ? parseFloat(ticketDetails?.installment_min_amount ?? 0)
        : 0,
      // event_image: "test_image",
    };

    delete updatedEventDetails["endHours"];
    delete updatedEventDetails["endMinutes"];
    delete updatedEventDetails["startHours"];
    delete updatedEventDetails["startMinutes"];
  
    return updatedEventDetails;
  } catch (error) {

    console.log(error,'errprr');
    
    
  }


};
export const createEvent = async (eventDetails) => {
  try {
    const response = await api.post(`/event/events`, {
      ...eventDetails,
    });
    if (response?.data?.success) {
      Toast().Success(response?.data?.message);
      return response?.data;
    }
  } catch (error) {
    Toast().Error(
      error?.response?.data?.message || error?.response?.data?.errors?.[0]?.msg
    );
  }
};

export const SearchOptions = async (url) => {
  try {
    const response = await api.get(`/${url}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const getData =(url, showMessage=false)=> requestHandler(()=> api.get(`/${url}`), showMessage );
export const getAll =(url, showMessage=false)=> requestHandler(()=> api.get(`/${url}`), showMessage );
export const postData = (url, data, showMessage = true) => requestHandler(() => api.post(`/${url}`, data), showMessage);
export const updateData = (url, data, showMessage = true) => requestHandler(() => api.put(`/${url}`, data), showMessage);
export const deleteData = (url, showMessage = true) => requestHandler(() => api.delete(`/${url}`), showMessage);
export const uploadImage = (url, data, showMessage = true) => requestHandler(() => api.post(`/${url}`, data, { headers: { 'Content-Type': 'multipart/form-data' }, }), showMessage);


// export const getData = async (url, showMessage = true) => {
//   try {
//     const result = await api.get(`/${url}`);
//     if (showMessage) {
//       Toast().Success(result?.data?.message || "");
//     }
//     return result;
//   } catch (error) {
//     if (showMessage) {
//       Toast().Error(
//         error?.response?.data?.message ||
//           error?.response?.data?.errors?.[0]?.msg ||
//           ""
//       );
//     }

//     return error;
//   }
// };



// export const getAll = async (url, showMessage = true) => {
//   try {
//     const result = await api.get(`/${url}`);
//     if (showMessage) {
//       Toast().Success(result?.data?.message || "");
//     }
//     return result;
//   } catch (error) {
//     if (showMessage) {
//       Toast().Error(
//         error?.response?.data?.message ||
//           error?.response?.data?.errors?.[0]?.msg ||
//           ""
//       );
//     }
//     return error;
//   }
// };

// export const postData = async (url, data, showMessage = true) => {
//   try {
//     const result = await api.post(`/${url}`, data);
//     if (showMessage) {
//       Toast().Success(result?.data?.message || "");
//     }
//     return result;
//   } catch (error) {
//     Toast().Error(
//       error?.response?.data?.message ||
//         error?.response?.data?.errors?.[0]?.msg ||
//         ""
//     );
//     return error;
//   }
// };

// export const updateData = async (url, data, showMessage = true) => {
//   try {
//     const result = await api.put(`/${url}`, data);
//     if (showMessage) {
//       Toast().Success(result?.data?.message || "");
//     }
//     return result;
//   } catch (error) {
//     if (showMessage) {
//       Toast().Error(
//         error?.response?.data?.message ||
//           error?.response?.data?.errors?.[0]?.msg ||
//           ""
//       );
//     }
//     return error;
//   }
// };

// export const deleteData = async (url, showMessage = true) => {
//   try {
//     const result = await api.delete(`/${url}`);
//     if (showMessage) {
//       Toast().Success(result?.data?.message || "");
//     }
//     return result;
//   } catch (error) {
//     if (showMessage) {
//       Toast().Error(
//         error?.response?.data?.message ||
//           error?.response?.data?.errors?.[0]?.msg ||
//           ""
//       );
//     }

//     return error;
//   }
// };

// export const uploadImage = async (url, data, showMessage = true) => {
//   try {
//     const result = await api.post(`/${url}`, data, {
//       headers: {
//         "Content-Type": "multipart/form-data", // This is crucial to inform the server you're sending form data
//       },
//     });
//     if (showMessage) {
//       Toast().Success(result?.data?.message || "");
//     }

//     return result;
//   } catch (error) {
//     if (showMessage) {
//       Toast().Error(
//         error?.response?.data?.message ||
//           error?.response?.data?.errors?.[0]?.msg ||
//           ""
//       );
//     }
//     return error;
//   }
// };
